"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePresetRequest = void 0;
const use_storage_query_1 = require("./use-storage-query");
const usePresetRequest = (productName, presetPartner, presetName) => {
    const queryResult = (0, use_storage_query_1.useStorageQuery)('presetRequest', `/presets-arch-vzr/${presetPartner}/${productName}/${presetName}.json`, [presetPartner, presetName], {
        enabled: !!presetPartner && !!presetName,
        staleTime: 100000000,
    });
    const { isLoading, error, data, refetch, isFetching, isRefetching, status } = queryResult;
    let res;
    if (!isLoading && data) {
        res = data;
    }
    return {
        isLoading,
        error,
        res,
        refetch,
        isFetching,
        isRefetching,
        status,
    };
};
exports.usePresetRequest = usePresetRequest;
